





















import AbpBase from '@/lib/abpbase'
import { Component, Prop,Watch } from 'vue-property-decorator'
import MediaItem from '@/store/entities/mediaItem'
import Util from '@/lib/util'
@Component({
    components:{  }
})
export default class MediaBox extends AbpBase {
    @Prop({type:Object,default: () => new MediaItem()}) mediaItem:MediaItem;
    @Prop({type:Number,default: 0}) state:Number;
    pickImage(){
        if(this.state == 0){
            this.$emit("takeImage" , this.mediaItem);
        }    
        if(this.state  == 1){
            this.$store.commit('mediapicker/setType',1);
            this.$store.commit('mediapicker/setShow',true)
        }   
        if(this.state  == 2){
            this.$store.commit('mediapicker/setType',2);
            this.$store.commit('mediapicker/setShow',true)
        }  
        if(this.state  == 3){
            this.$store.commit('mediapicker/setType',3);
            this.$store.commit('mediapicker/setShow',true)
        }    
        if(this.state  == 4){
            this.$store.commit('mediapicker/setType',4);
            this.$store.commit('mediapicker/setShow',true)
        } 
    }
    getImageUrl(imgUrl,mediaType){
        console.log(imgUrl, mediaType)
        if(imgUrl == null || imgUrl == undefined || imgUrl == ""){
            return "https://via.placeholder.com/200";
        }
        if(mediaType == null || mediaType == undefined || mediaType == ""){
            return imgUrl;
        }
        imgUrl = Util.getImgFromMediaType(mediaType,imgUrl);
        return imgUrl;         
    }
    get title(){
        let title = this.mediaItem.customName;
        if(title != undefined ){
            if(title.length > 20){
                return title.substring(0,21)
            }
            return title;
        }
        return "";
    }
};
